import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

//import { Router, ROUTER_DIRECTIVES } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';

//import { AdalService } from './adal/ts/core';
//import { AdalService } from './adal/ts/services/adal.service';
//import { AdalService } from 'angular2-adal/core';

//import { AdalService } from './adal/adal.service';
import { AppSettingsService } from './services/appsettings.service';
import { UserInfoService } from './services/userinfo.service';

//import { AdConfigService } from './services/adconfig.service';

//import { ANGULAR2_ADAL_PROVIDERS } from './adal/ts/core';

//import { ProgressBarService } from './services/progressbar.service'
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';
import { AdalService } from './adal/adal.service';

@Component({
    selector: 'portal-one-app',
    template: require('./app.component.html'),
    //styles: [
    //    require('bootstrap/dist/css/bootstrap.css')
    //],
    //directives: [ROUTER_DIRECTIVES],
    //styleUrls: ['bootstrap/dist/css/bootstrap']
    //providers: [AdalService, AdConfigService]
})

export class AppComponent {
    private sub: any;
    public userInfo: any = {};

    constructor(
        private progressBarService: SlimLoadingBarService,
        private router: Router,
        private adalService: AdalService,
        private appSettingsService: AppSettingsService,
        private userInfoService: UserInfoService
    )
     {
        //this.adalService.init(this.appSettingsService.adalConfig);
        //this.adalService.init(this.adConfigService.adalConfig);
        //else {
        //    this.adalService.clearCache();
        //    this.adalService.login();
        //}

         this.userInfoService.getUserInfo()
             .subscribe((info) => {
                 //this.userInfo = info;
             });

         this.userInfo = this.adalService.userInfo;
        //this.appSettingsService.getAppSettings().then(() => {
        //    this.adalService.init(this.appSettingsService.adalConfig);
        //    this.appSettingsService.setRedirectPath(window.location.pathname);
        //    this.appSettingsService.setRedirectUri(window.location.origin + window.location.pathname);

        //    this.adalService.handleWindowCallback();

        //    //if (!this.adalService.userInfo.isAuthenticated) {
        //    //    this.adalService.clearCache();
        //    //    this.adalService.login();
        //    //    //this.router.navigate([this.appSettingsService.adalConfig.redirectPath]);
        //    //}
        //})

        
        

        //this.sub = this.router.events.subscribe(event => {
        //    if (event instanceof NavigationStart) {
        //        this.progressBarService.start();
        //    } else if (event instanceof NavigationEnd ||
        //        event instanceof NavigationCancel ||
        //        event instanceof NavigationError) {
        //        this.progressBarService.complete();
        //    }
        //}, (error: any) => {
        //    this.progressBarService.complete();
        //});
    }

    public signIn() {
        //this.router.navigate(["/signin"]); 
        //this.adalService.clearCache();
        this.adalService.login();
        //window.location.href = "/signin";
    }

    public signOut() {
        this.adalService.logOut();
        //window.location.href = "/signout";
    }
}


// WEBPACK FOOTER //
// ./app/app.component.ts